import { from } from "rxjs/observable/from";

export { Api } from "./project_providers/api/api";
export { User } from "./project_providers/user/user";
export { Project } from "./project_providers/project/project";
export { Master } from "./project_providers/master/master";
export { Schedule } from "./project_providers/schedule/schedule";
export { Task } from "./project_providers/task/task";
export { Notes } from "./project_providers/notes/notes";
export { Dokumen } from "./project_providers/dokumen/dokumen";
export { Subscriber } from "./project_providers/subscriber/subscriber";
export { Invoice } from "./project_providers/invoice/invoice";

export { ResourceTreeProvider } from "./resource-tree/resource-tree";
export { AprovalProvider } from "./myradiant/aproval/provider";

//export providers untuk my radiant
export { Api as ApiMyRadiant } from "./api/api";
export { User as UserMyRadiant } from "./myradiant/user/user";
export { Login as LoginMyRadiant } from "./myradiant/login/login";
export { News as NewsMyRadiant } from "./myradiant/news/news";
export { NotesProvider as NotesMyTeamProvider } from "./myradiant/notes/provider";
export { Repository as RepositoryMyRadiant } from "./resources/repository";
export { Utility as UtilityMyRadiant } from "./resources/utility";
export { Helper as HelperMyRadiant } from "./resources/helper";
export { News } from "./myradiant/news/news";
export { NotificationProvider } from "./myradiant/notification/provider";
//export untuk presensi
export {
  Permit as PermitProvider,
  Overtime as OvertimeProvider,
} from "./presensi";

export { Me } from "./activity";
export { FaskerProvider } from "./myradiant/fasker/provider";

// export assets
export {
  Api as ApiAsset,
  Master as MasterAsset,
  Tracking as TrackingAsset,
  Reviews,
  Dokumen as DokumenAsset,
  assetDocuments,
  User as UserAsset,
  Assignment,
  Item,
  TrackingFasker,
} from "./asset";

//for sub app Marketing
export {
  Api as ApiMarketing,
  Tender as TenderMarketing,
  Master as MasterMarketing,
  Schedule as ScheduleMarketing,
  Task as TaskMarketing,
  Notes as NotesMarketing,
  User as UserMarketing,
  Dokumen as DokumenMarketing,
  Subscriber as SubscriberMarketing,
} from "./marketing";

export { PresensiProvider } from "./myradiant/presensi/provider";

//survey
export { Form } from "./survey";

/*
 * * for Approval Mobile
 */
export * from "./aproval_erp";

export { Employee as EmployeeAttendanceProvider } from "./attendance";



// WEBPACK FOOTER //
// ./src/providers/index.ts